module.exports = __webpack_public_path__ + "img/symbol_9.6e63a0ed.png";